import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card shadow mx-0 mb-4" }
const _hoisted_2 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_4 = { class: "m-0 font-weight-bold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.", -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  key: 0,
  class: "container"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-left" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, " Select a Customer to add it to Commercial Group: ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = { class: "input-group-append" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-backspace" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "col-12 text-left mt-2",
  style: {"background-color":"#f8f9fa","padding":"12px"}
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("b", null, "ID:", -1)
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("b", null, "Name:", -1)
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("b", null, "Lastname:", -1)
const _hoisted_25 = { class: "col-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("b", null, "Email:", -1)
const _hoisted_27 = { class: "col-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("b", { class: "mr-1" }, "Current Group:", -1)
const _hoisted_29 = { class: "col-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("b", null, "Date Of Birth:", -1)
const _hoisted_31 = { class: "col-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("b", null, "Occupation:", -1)
const _hoisted_33 = { class: "col-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("b", null, "Type :", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fas fa-male" }, null, -1)
const _hoisted_40 = { class: "col-12 text-right" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Add customer ")
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_44 = { class: "row mt-4" }
const _hoisted_45 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" }
const _hoisted_49 = /*#__PURE__*/_createVNode("h4", { style: {"background-color":"#f8f9fa","padding":"12px"} }, " Customer Details ", -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "table text-left details-table" }
const _hoisted_53 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Id", -1)
const _hoisted_54 = { class: "table-list-value" }
const _hoisted_55 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Email", -1)
const _hoisted_56 = { class: "table-list-value" }
const _hoisted_57 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Full name", -1)
const _hoisted_58 = { class: "table-list-value" }
const _hoisted_59 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Reference code", -1)
const _hoisted_60 = { class: "table-list-value" }
const _hoisted_61 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Date of birth", -1)
const _hoisted_62 = { class: "table-list-value" }
const _hoisted_63 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Type", -1)
const _hoisted_64 = { class: "table-list-value" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fas fa-male" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, " PEP ", -1)
const _hoisted_70 = { class: "table-list-value" }
const _hoisted_71 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Occupation", -1)
const _hoisted_72 = { class: "table-list-value" }
const _hoisted_73 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Commercial Group", -1)
const _hoisted_74 = { class: "table-list-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "#",
        class: "text-dark mr-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
      }, [
        _hoisted_3
      ]),
      _createVNode("h6", _hoisted_4, [
        _createTextVNode(" Manage Customers #" + _toDisplayString(_ctx.selectedCommercialGroup?.id) + " ", 1),
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      (_ctx.selectedCommercialGroup)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("h4", null, _toDisplayString(_ctx.selectedCommercialGroup?.name), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_AutoComplete, {
                    autofocus: "autofocus",
                    placeholer: "Search...",
                    field: "fullName",
                    modelValue: _ctx.searchText,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchText = $event)),
                    suggestions: _ctx.resultsSearch,
                    onComplete: _ctx.getFilteredUsers,
                    onItemSelect: _ctx.onSelectCustomer
                  }, {
                    item: _withCtx((slotProps) => [
                      _createVNode("div", null, _toDisplayString(slotProps.item.fullName) + " - " + _toDisplayString(_ctx.hideEmail(slotProps.item.email)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect"]),
                  _createVNode("div", _hoisted_15, [
                    (_ctx.currentCustomer?.id)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                          type: "button",
                          class: "btn btn-primary"
                        }, [
                          _hoisted_16
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.currentCustomer?.id)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentCustomer.id), 1)
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentCustomer.firstName || '--'), 1)
                      ]),
                      _createVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentCustomer.lastName || '--'), 1)
                      ]),
                      _createVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_ctx.hideEmail(_ctx.currentCustomer.email)), 1)
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createTextVNode(" " + _toDisplayString(_ctx.commercialGroups.find(
                    group => group.id === _ctx.currentCustomer.planId
                  )?.name), 1)
                      ]),
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentCustomer.dateOfBirth || '--'), 1)
                      ]),
                      _createVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.currentCustomer.occupation || '--'), 1)
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _hoisted_35,
                        (_ctx.currentCustomer.corporate)
                          ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_36, [
                              _hoisted_37
                            ], 512)), [
                              [
                                _directive_tooltip,
                                'Business',
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _withDirectives((_openBlock(), _createBlock("span", _hoisted_38, [
                              _hoisted_39
                            ], 512)), [
                              [
                                _directive_tooltip,
                                'Personal',
                                void 0,
                                { top: true }
                              ]
                            ])
                      ]),
                      _createVNode("div", _hoisted_40, [
                        _createVNode("button", {
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.addCustomer(
                      Number(this.$route.params.id),
                      _ctx.currentCustomer.id
                    )
                  )),
                          class: "btn btn-sm btn-success"
                        }, [
                          _hoisted_41,
                          _hoisted_42
                        ])
                      ]),
                      _hoisted_43
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode(_component_DataTable, {
                      value: _ctx.getUsersFromCommercialGroup,
                      selectionMode: "single",
                      dataKey: "id",
                      selection: _ctx.customerForDetails,
                      "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => (_ctx.customerForDetails = $event)),
                      paginator: true,
                      responsiveLayout: "true",
                      rows: 5,
                      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                      rowsPerPageOptions: [5, 15, 50],
                      currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          field: "firstName",
                          header: "Name"
                        }),
                        _createVNode(_component_Column, { header: "Email" }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value", "selection"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_48, [
                _hoisted_49,
                (!_ctx.customerForDetails?.id > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_50, " Please Select a Customer "))
                  : (_openBlock(), _createBlock("div", _hoisted_51, [
                      _createVNode("table", _hoisted_52, [
                        _createVNode("tr", null, [
                          _hoisted_53,
                          _createVNode("td", _hoisted_54, _toDisplayString(_ctx.customerForDetails.id), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_55,
                          _createVNode("td", _hoisted_56, _toDisplayString(_ctx.hideEmail(_ctx.customerForDetails.email)), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_57,
                          _createVNode("td", _hoisted_58, _toDisplayString(_ctx.customerForDetails.firstName || '--') + " " + _toDisplayString(_ctx.customerForDetails.lastName || '--'), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_59,
                          _createVNode("td", _hoisted_60, _toDisplayString(_ctx.customerForDetails.referenceCode || '--'), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_61,
                          _createVNode("td", _hoisted_62, _toDisplayString(_ctx.customerForDetails.dateOfBirth || '--'), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_63,
                          _createVNode("td", _hoisted_64, [
                            (_ctx.customerForDetails.corporate)
                              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_65, [
                                  _hoisted_66
                                ], 512)), [
                                  [
                                    _directive_tooltip,
                                    'Business',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createBlock("span", _hoisted_67, [
                                  _hoisted_68
                                ], 512)), [
                                  [
                                    _directive_tooltip,
                                    'Personal',
                                    void 0,
                                    { top: true }
                                  ]
                                ])
                          ])
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_69,
                          _createVNode("td", _hoisted_70, _toDisplayString(_ctx.customerForDetails.relationWithGovernment ? 'YES' : 'NO'), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_71,
                          _createVNode("td", _hoisted_72, _toDisplayString(_ctx.customerForDetails.occupation || '--'), 1)
                        ]),
                        _createVNode("tr", null, [
                          _hoisted_73,
                          _createVNode("td", _hoisted_74, [
                            _createVNode(_component_Dropdown, {
                              options: _ctx.commercialGroups,
                              modelValue: _ctx.customerForDetails.planId,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.customerForDetails.planId = $event)),
                              optionLabel: "name",
                              optionValue: "id",
                              filter: true,
                              filterPlaceholder: "Find commercial group",
                              onChange: _ctx.changeCommercialGroup
                            }, null, 8, ["options", "modelValue", "onChange"])
                          ])
                        ])
                      ])
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}